import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [
    SidebarComponent,
    SidebarItemComponent
  ],
  imports: [
    CommonModule,
    IconModule
  ],
  exports: [
    SidebarComponent,
    SidebarItemComponent
  ]
})
export class SidebarModule { }
